import { render } from "./EtkinliklerDetayView.vue?vue&type=template&id=d1e0b948"
import script from "./EtkinliklerDetayView.vue?vue&type=script&lang=js"
export * from "./EtkinliklerDetayView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__